import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { open } from '../../../../modules/modal/actions';
import Translation from '../../../i18n/Translation';

const mapDispatchToProps = {
  showLearnMore: open.bind(null, { componentName: 'TransferInfo' })
};

const TransferFailed = ({ showLearnMore }) => (
  <div>
    <Translation section="transfer" label="requestError" />{' '}
    <span className="to-be-paid-out__link" onClick={showLearnMore}>
      <Translation section="common" label="learnMore" />
    </span>
  </div>
);

TransferFailed.propTypes = {
  showLearnMore: PropTypes.func.isRequired
};

export default connect(null, mapDispatchToProps)(TransferFailed);
